export const ValidationError = ({ formik, property }) => {
  return formik?.touched[property] && formik?.errors[property]
    ? <small className="form-text text-danger">{formik.errors[property]}</small>
    : null
}
